import {createSvgIcon} from '../create-svg-icon';

export const PriorityHighIcon = createSvgIcon(
  [<circle cx="12" cy="19" r="2" key="0" />,<path d="M10 3h4v12h-4z" key="1" />,]
, 'PriorityHighOutlined');
